import styled from "styled-components";

export const Wrapper = styled.div`
  z-index: ${({ theme }) => theme.zIndices.banner};
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 68px;
  height: 100vh;
  padding: 15px 10px;
  background: var(--black);
  transform: translate3d(${({ active }) => (active ? "0" : "-100%")}, 0, 0);
  transition: transform 0.6s ease;
  will-change: transform;
  overflow: visible;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    display: flex;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  cursor: default;
`;

export const CompanyButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 8px;
  background: ${({ isSelected }) =>
    isSelected ? "var(--brand-ideolo)" : "rgba(255, 255, 255, 0.1)"};
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;

  &:hover {
    background: ${({ isSelected }) =>
      isSelected ? "var(--brand-ideolo)" : "rgba(255, 255, 255, 0.15)"};
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -3px;
    width: 3px;
    height: 100%;
    background: var(--brand-ideolo);
    opacity: ${({ isSelected }) => (isSelected ? "1" : "0")};
    border-radius: 0 2px 2px 0;
    transition: opacity 0.2s ease;
  }
`;

export const CompanyInitials = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: white;
  user-select: none;
`;
